import { render } from "./AddEditInk.vue?vue&type=template&id=13a03e4d"
import script from "./AddEditInk.vue?vue&type=script&lang=js"
export * from "./AddEditInk.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vinit.kariatukaran/hofmp-hp/hofmp/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__